// extracted by mini-css-extract-plugin
export default {"root":"q3x8qUcjIqVeyNgzoTrN ihUZOip2HURGjOTCTTUt","label":"OkroRJ5Oyfj2EUfe_6Kl muJQCgSZXlF4gch2OEP_ d_wzCwbNBA3zFXSeM1ic"};